import * as Yup from "yup";
import React, { useState } from "react";
import { errorToast, successToast } from "../Toast";
import { Field, Form, Formik, ErrorMessage } from "formik";

import { createDocumentApi } from "../../services/_document";

const createDocumentInitialValues = {
  name: "",
  status: "",
};

interface AddDocumentModalProps {
  addDocumentModal: boolean;
  closeAddDocumentModal: () => void;
  onDocumentCreated: any;
}

const createDocumentValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  status: Yup.string().required("Status is required"),
});

const AddDocumentModal: React.FC<AddDocumentModalProps> = ({
  addDocumentModal,
  closeAddDocumentModal,
  onDocumentCreated,
}) => {
  const [submitLoader, setSubmitLoader] = useState(false);
  const handleSubmit = async (values: any, { resetForm }: any) => {
    setSubmitLoader(true);
    const updatedValues = {
      ...values,
      status: values.status === "true",
    };
    const result: any = await createDocumentApi(updatedValues);
    if (result.isSuccess) {
      setSubmitLoader(false);
      resetForm({ values: createDocumentInitialValues });
      successToast(result.message);
      closeAddDocumentModal();
      onDocumentCreated(result.data);
    } else {
      setSubmitLoader(false);
      errorToast(result.message);
    }
    return;
  };

  return (
    <>
      {addDocumentModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div
            className="modal fade show"
            id="addDocumentModal"
            tabIndex={-3}
            aria-hidden={!addDocumentModal}
            style={{ display: addDocumentModal ? "block" : "none" }}
          >
            <div
              className="modal fade show"
              id="addDocumentModal"
              tabIndex={-3}
              aria-hidden={!addDocumentModal}
              style={{ display: addDocumentModal ? "block" : "none" }}
            >
              <div
                className="modal fade show"
                id="addDocumentModal"
                tabIndex={-3}
                aria-hidden={!addDocumentModal}
                style={{ display: addDocumentModal ? "block" : "none" }}
              >
                <div className="modal-dialog modal-lg modal-simple modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body p-4 d-flex align-items-center justify-content-center">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={closeAddDocumentModal}
                      ></button>
                      <div className="w-100">
                        <div className="text-center mb-4">
                          <h4 className="mb-2">Add Document</h4>
                        </div>

                        <Formik
                          initialValues={createDocumentInitialValues}
                          validationSchema={createDocumentValidationSchema}
                          onSubmit={handleSubmit}
                        >
                          {({ values, handleChange }) => (
                            <Form className="dt_adv_search w-100">
                              <div className="row justify-content-center">
                                <div className="col-12 col-lg-12 col-lg-4">
                                  <div className="row g-3">
                                    <div className="col-12 col-lg-6">
                                      <label
                                        htmlFor="name"
                                        className="form-label"
                                        style={{ fontSize: "0.9375rem" }}
                                      >
                                        Name:{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <Field
                                        id="name"
                                        name="name"
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter name"
                                        value={values.name}
                                        onChange={handleChange}
                                      />
                                      <ErrorMessage
                                        name="name"
                                        className="text-danger"
                                        component="div"
                                      />
                                    </div>
                                    <div className="col-12 col-md-6">
                                      <label
                                        htmlFor="status"
                                        className="form-label"
                                        style={{ fontSize: "0.9375rem" }}
                                      >
                                        Status:{" "}
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        id="status"
                                        name="status"
                                        className="form-select"
                                        value={values.status}
                                        onChange={handleChange}
                                      >
                                        <option value="">Select Status</option>
                                        <option value="true">Active</option>
                                        <option value="false">Inactive</option>
                                      </select>
                                      <ErrorMessage
                                        name="status"
                                        className="text-danger"
                                        component="div"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="text-center mt-4">
                                <button
                                  type="submit"
                                  className="btn btn-primary me-3"
                                  disabled={submitLoader}
                                >
                                  {submitLoader && (
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  )}
                                  Add Document
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-label-secondary"
                                  onClick={closeAddDocumentModal}
                                >
                                  Cancel
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AddDocumentModal;
